import React, { useState } from "react";
import jsDig from "utils/jsDig";
import LiteMetricTable from "dashboards/lite/LiteMetricTable";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import ObjectivePicker from "./ObjectivePicker";
import { capitalize } from "lodash";
export default function SocialDashboard(props) {
  console.log(props)
  const metricTableDimensions = jsDig(["overall", "total", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "total", "spend"], props.table_data)) : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", "YTD", "Total"];
  // Convert utc date to local time in this format 12:30 PM, 12/31/2021
  const lastDataPull = new Date(jsDig(["last_data_pull"], props)).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });

  const thisYear = new Date().getFullYear();
  const lastYear = thisYear - 1;

  let mainIcon = require("images/lite/icons/social.svg");
  mainIcon = <div className="paid-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>

  const [dashboardObjective, setDashboardObjective] = useState(props.client_account.dashboard_objective ? props.client_account.dashboard_objective : "sales");
  let revenueOrConversions = dashboardObjective == "sales" ? "revenue" : "conversions";
  let roasOrCpa = dashboardObjective == "sales" ? "roas" : "cpa";

  return (
    <>
      <div className="lite-dashboard paid-social-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>Paid Social Dashboard</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
          <div className="dashboard-header-right flex-end">
            <div className="most-recent-refresh">
              <small id="most-recent-refresh">Last refresh: {props.last_data_pull ? lastDataPull : "Never"}</small>
            </div>
            <div className="objective-refresh-container">
              <ObjectivePicker setDashboardObjective={setDashboardObjective} dashboardObjective={dashboardObjective} />
              <LiteRefresh currentDashboard={"social"} accountId={props.client_account.id} alreadyPulling={props.current_data_pulls} />
            </div>
          </div>
        </div>
        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <h3>Social Spend L60D</h3>
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "spend", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "spend", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "spend", "data"], props.chart_data)}
                metric="spend"
              />
            </div>
            <div className="lite-metric-chart">
              <h3>Social {capitalize(revenueOrConversions)} L60D</h3>
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", revenueOrConversions, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", revenueOrConversions, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", revenueOrConversions, "data"], props.chart_data)}
                metric={revenueOrConversions}
              />
            </div>
            <div className="lite-metric-chart">
              <h3>Social {roasOrCpa.toUpperCase()} L60D</h3>
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", roasOrCpa, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", roasOrCpa, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", roasOrCpa, "data"], props.chart_data)}
                metric={roasOrCpa}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["overall", "total"], props.table_data)}
                tableName="Total Social"
                dimensions={metricTableDimensions}
              />
            </div>
            <div className="lite-metric-chart">
              <h3>Prospecting vs. Remarketing L60D</h3>
              <LiteLineChart 
                datasetNames={jsDig(["overall", "prospecting_vs_remarketing", "spend", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "prospecting_vs_remarketing", "spend", "labels"], props.chart_data)}
                data={jsDig(["overall", "prospecting_vs_remarketing", "spend", "data"], props.chart_data)}
                metric="stacked"
                tooltipData={jsDig(["overall", "prospecting_vs_remarketing", "spend", "tooltip_data"], props.chart_data)}
                tooltipMetric="spend"
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", "frequency", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["facebook_ads"], props.table_data)}
                tableName="Facebook / Instagram"
                skipPrev={true}
                dimensions={metricTableDimensions}
                groups={["Total", "Prospecting", "Remarketing", "Uncategorized"]}
              />
            </div>
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", "frequency", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["tiktok_ads"], props.table_data)}
                tableName="Tiktok"
                skipPrev={true}
                dimensions={metricTableDimensions}
                groups={["Total", "Prospecting", "Remarketing", "Uncategorized"]}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", "frequency", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["youtube"], props.table_data)}
                tableName="Youtube"
                skipPrev={true}
                dimensions={metricTableDimensions}
                groups={["Total", "Prospecting", "Remarketing", "Uncategorized"]}
              />
            </div>
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", "frequency", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[thisYear, "Y/Y"]}
                data={jsDig(["pinterest_ads"], props.table_data)}
                tableName="Pinterest"
                skipPrev={true}
                dimensions={metricTableDimensions}
                groups={["Total", "Prospecting", "Remarketing", "Uncategorized"]}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["overall", "l60"], props.table_data)}
                tableName="Total Social - Daily L60D"
                dimensions={jsDig(["overall", "l60", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "l60", "spend"], props.table_data)) : []}
                topSummaryRow={{dimension: "L7D >", data: jsDig(["overall", "l7"], props.table_data)}}
                collapsed={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
